import axios from 'axios';

export const getPractices = async () => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/practice/`;
    try {
        const response = await axios.get(apiUrl);
        console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching practices:', error);
        throw error;
    }
};

export const getLives = async () => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/practice/live`;
    try {
        const response = await axios.get(apiUrl);
        console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching practices:', error);
        throw error;
    }
};

export const getPracticesByTags = async (tags) => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/practice/by-tag`;
    const tagQuery = tags.join(",");

    try {
        const response = await axios.get(apiUrl, {
            params: { tags: tagQuery },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching practices by tags:', error);
        throw error;
    }
};

export const assemblePractice = async ({ level, type, duration, tags }, token) => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/constructor/assemble`;
    const tagQuery = tags.join(",");
    try {
        console.log(token)
        const response = await axios.get(apiUrl, {
            params: { level, type, duration, tags: tagQuery },
            headers: {
                authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error assembling practice', error);
        throw error;
    }
};


